import { ApiResponse, StaticPageWrapper } from "../../../types";
import { getRequest } from "../configuration";
import getApiWithVersion from "../apis";
import { API_VERSION } from "../../constants/common";
const api = getApiWithVersion(API_VERSION.V1);

export interface StaticPage{
    getPageDetails(pageName: string): Promise<ApiResponse<StaticPageWrapper>>;
}

const static_page: StaticPage = {
     getPageDetails(pageName) {
        return getRequest(api.STATIC_PAGE, pageName);
    }
}

export default static_page

